import { createSlice } from '@reduxjs/toolkit';

const restorePasswordSlice = createSlice({
  name: 'restorePassword',
  initialState: {
    loginToRestoreFor: '',

    isForgotRequestSending: false,
    isNewPasswordSetting: false,
  },
  reducers: {
    sendForgotRequest: (state, action) => {
      state.loginToRestoreFor = action.payload;
      state.isForgotRequestSending = true;
    },
    sendForgotRequestSuccess: state => {
      state.isForgotRequestSending = false;
    },
    sendForgotRequestFailuer: state => {
      state.isForgotRequestSending = false;
    },
    setNewPassword: (state, action) => {
      state.isNewPasswordSetting = true;
    },
    setNewPasswordSuccess: state => {
      state.isNewPasswordSetting = false;
    },
    setNewPasswordFailuer: state => {
      state.isNewPasswordSetting = false;
    },
  },
});

export const {
  sendForgotRequest,
  sendForgotRequestSuccess,
  sendForgotRequestFailuer,

  setNewPassword,
  setNewPasswordSuccess,
  setNewPasswordFailuer,
} = restorePasswordSlice.actions;

export default restorePasswordSlice.reducer;
